module.exports = __webpack_public_path__ + "media/pricing/digital-a74f8712.png";